"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _novageSkincareAdvisorContext = require("./novageSkincareAdvisorContext");
Object.keys(_novageSkincareAdvisorContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _novageSkincareAdvisorContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _novageSkincareAdvisorContext[key];
    }
  });
});
